$(document).ready(function() {
  if (window.location.href.indexOf("?page=2") > -1) {
    $("#div1").insertAfter('.products-grid-view > li:nth-child(3)');
  }
    if (( window.location.href.indexOf("kawaiislimecompany.com") < 0 ) || ( window.location.href.indexOf("kawaii-slime-company") < 0 ) ) {
  //window.location.replace("https://www.kawaiislimecompany.com/");
}

  
 //setTimeout(function() {
   //$( "ul.products-grid-view.collection-list li" ).each(function() {
   //if( $(this).find(".spr-summary-caption").text() == 'No reviews yet') {                                    
//var replaced = '<span class="spr-starrating spr-badge-starrating"><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i></span>';
//$(this).find(".spr-summary").append(replaced);
//   }
  //    $('span.spr-starrating.spr-summary-starrating').addClass('show');
   //});
     //  }, 3400);                                 
 
var flag = 0;
$('body').on('DOMSubtreeModified', '#cart-drawer-inner', function(){
  if(flag == 0) {
    $.getJSON("https://ipgeolocation.abstractapi.com/v1/?api_key=03af250bd0ad46f8abda91051d35dd76", function(data) {
      if ($(data.country_code === 'US').length > 0) {
        $('.cart-percentage-usa').css('display','block');
      }
      else if ( !$(data.country_code === 'US').length ) {
        $('.cart-percentage-usa').css('display','none');
      }
      flag = 1;
    });
  }
});
  
  
  if (window.location.href.indexOf("wishlist") > -1) {
      $('.main-content').find('.wishlist-sidebar').show();
      $('.main-content').find('.main-grid').addClass('post-large--three-quarters col-main');
    }
  else {
    $('.main-content').find('.wishlist-sidebar').remove();
    }
  

  setTimeout(
  function() 
  {
  if (window.location.href.indexOf("wishlist") > -1) {
      $('.main-content').find('.wishlist-cartoon').insertAfter('.titletext');
    $('#heading-breadcrumbs').find('.col-md-6').eq(0).addClass('col-md-7').removeClass('col-md-6');
    $('#heading-breadcrumbs').find('.allbuttons').addClass('col-md-5').removeClass('col-md-6');
    }
  else {
    $('.main-content').find('.wishlist-cartoon').hide();
    }
  }, 1500);

// dom ready ended below
});

$(document).ready(function() {
  $(".customer-tab-list li").click(function(){
    var get_order_addclss = $(this).attr('data-id');
    if(get_order_addclss == "past_order") {
       $('body').addClass('gs-body-bg-orders');
    } 
    else {
        $('body').removeClass('gs-body-bg-orders');
    }
  });
  
  
  var str1   = window.location.href;    
  var str2 = "past_order";
  if(str1.indexOf(str2) != -1){
      $('body').addClass('gs-body-bg-orders');
   }
  
   
  
  
  $(".gs-mega-menu-new li").click(function(){

     var str1   = window.location.href;    
     var str2 = "past_order";
     if(str1.indexOf(str2) == -1){
      $('body').addClass('gs-body-bg-orders');
     } 
     else { // alert('aaa');
      $('body').removeClass('gs-body-bg-orders'); 
     }
  });
  
});  


$(document).ready(function() {
  var pathname = window.location.href;
  
  if (pathname == "https://www.kawaiislimecompany.com/account") {
     $('.gs-active-on-page').addClass('active');
  }
 // 
  
  $(".gs-all-orders-span").click(function(){
       $('.gs-all-order-view').trigger('click');
  });
  if (window.matchMedia('(max-width: 767px)').matches) { 
  $(".gs-all-orders-span").click(function(){
       setTimeout(function(){  
        location.reload(); 
       }, 1000);
  });
  }
  $(".gs-past-order-red").click(function(){
    //var gettextpost = $(this).find('.dash_content').text();
    //alert(gettextpost);
   // if(gettextpost == "Past Orders") {
    //   $('.gs-all-order-view').trigger('click');
   // }
   setTimeout(function(){  
    location.reload(); 
   }, 1000);  
  });
 if (window.matchMedia('(max-width: 767px)').matches) { 
 // $('.gs-showonclick-tab').hide();
  $(".mob-sidebar-hdr").click(function(){
      // $('.mob-ordr-body').slideToggle();
      // $('.gs-showonclick-tab').slideToggle();
  });
 }
  
  //$(".gs-click-set-open").click(function(){
    //$('body').addClass('gs-body-hide');
  //});
 // $(".new-mobile-menu-account div#slidedown-modal").click(function(){
    //$('body').removeClass('gs-body-hide');
  //});
  
  $(".mob-sidebar-hdr").click(function(){
    //$(".mobile_account_toggle").addClass('openpop');
    $(".mobile_account_toggle").slideDown(500);
    $('body').addClass('gs-body-hide');
  });  
  $(".gs-new-close").click(function(){
     //$(".mobile_account_toggle").removeClass('openpop');
     $(".mobile_account_toggle").slideUp(500);
     $('body').removeClass('gs-body-hide');
  });
  $(".gs-click-set-open").click(function(){
    //$(".mobile_account_toggle").addClass('openpop');
    $(".mobile_account_toggle").slideDown(500);
    $('body').addClass('gs-body-hide');
  });
  
  //back button
  if(performance.navigation.type == 2) { 
     // $("a#ToggleDown").click(function(){
       setTimeout(function(){  
         $('.checkmark').trigger('click');
       }, 2000);      
     //});
   // $('form.cart').removeClass('disable');
  }
  
  
  
  // loox reviews accordion trigger
  
$(document).on('click', '#trigger-reviews', function () {
  $('#two').css('display','block');
  $('#two').css('overflow','hidden');
    $('#accordion a:nth-child(2)').addClass('activer');
  });
$(document).on('click', '#trigger-reviews', function () {
  $('#tab4').trigger('click');
      $('html, body').animate({
        scrollTop: $("#tab4").offset().top
    }, 1000);
//   $('#tab4C').css('overflow','hidden');
//     $('#accordion a:nth-child(2)').addClass('activer');
  });

// $('#accordion a.plus').on('click' function () {
  
//   $(this).next('.').show();
//   $(this).next().show();
// });

  
}); 



// document.addEventListener("DOMContentLoaded", function() {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//       // Check if total quantity is 1 and the item title contains the word "Disguise"
//       const totalQuantity = cart.item_count;
//       const hasDisguiseItem = cart.items.some(item => item.title.includes("Disguise"));

//       // If the cart has only 1 item and it contains "Disguise" in the title, show an alert
//       if (totalQuantity === 1 && hasDisguiseItem) {
//         alert("Please remove the item with 'Disguise' from the cart.");
//       }
//     })
//     .catch(error => console.error('Error fetching cart data:', error));
// });

